import { generateCsv } from '../../api/Reporting/generateCsv.api';
import { getAllCategories } from '../../api/Reporting/getAllCategories.api';
import { getAllReportInfo } from '../../api/Reporting/getAllReportInfo.api';
import {
	GENERATE_CSV_FAIL,
	GENERATE_CSV_SUCCESS,
	GET_CATEGORIES_FAIL,
	GET_CATEGORIES_SUCCESS,
	GET_REPORTS_FAIL,
	GET_REPORTS_SUCCESS,
	SET_LOADING_SUCCESS,
} from './types';

export const getCategories = () => {
	return async (dispatch) => {
		try {
			getAllCategories((data) => {
				dispatch(getCategoriesSuccess(data));
			});
		} catch (error) {
			dispatch(getCategoriesFail(error));
		}
	};
};

export const getReports = () => {
	return async (dispatch) => {
		try {
			getAllReportInfo((data) => {
				dispatch(getReportsSuccess(data));
			});
		} catch (error) {
			dispatch(getReportsFail(error));
		}
	};
};

export const setLoading = (payload) => ({
	type: SET_LOADING_SUCCESS,
	payload,
});

const getReportsSuccess = (payload) => ({
	type: GET_REPORTS_SUCCESS,
	payload,
});

export const getReportsFail = (payload) => ({
	type: GET_REPORTS_FAIL,
	payload,
});

export const getCategoriesSuccess = (payload) => ({
	type: GET_CATEGORIES_SUCCESS,
	payload,
});
export const getCategoriesFail = (payload) => ({
	type: GET_CATEGORIES_FAIL,
	payload,
});
